<div class="load-file" *ngIf="this.listaArquivos.length > 0">
    <div class="load-file-title">
        <span><i class="fa fa-file me-1"></i>Carregando {{listaArquivos.length}} arquivos</span>
    </div>
    <div class="load-file-content">
        <div *ngFor="let item of this.obterListaArquivos()" class="load-file-line m-x-0">
            <div class="row pt-2 pb-2 my-auto">
                <div class="col-12">
                    <span class="file-icon text-center ms-1 me-1"
                        [style]="'background-color:' + item.colorIcon +';'">{{item.fileExt}}</span>
                    <span class="link me-2 d-inline">{{item.arquivo}}</span>
                    <span class="percent-badge pe-2">{{item.porcentagem.toFixed(0)}}%</span>
                </div>
            </div>
            <div class="row">
                <div class="col-12 ms-1">
                    <div class="progress d-inline">
                        <div class="progress-bar" role="progressbar" aria-valuemin="0" aria-valuemax="100"
                            [ngStyle]="{width: item.porcentagem + '%'}">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
